import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  language: z.enum(['en', 'zh-CN', 'es', 'fr', 'de', 'it', 'pt-BR', 'ja', 'ko', 'ar']),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  success: boolean;
  language: string;
};

export async function updateUserLanguage(input: InputType): Promise<OutputType> {
  const response = await fetch('/_api/user-settings/language', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: superjson.stringify(input),
    credentials: 'include',
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || 'Failed to update language');
  }

  return superjson.parse(await response.text());
}
